import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { IonicVue } from '@ionic/vue';
// CSS imports remain the same
import '@ionic/vue/css/core.css';
import '@ionic/vue/css/display.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/typography.css';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
// global components
import BaseLayout from '@/components/layout/BaseLayout.vue';
import { BaseButton } from '@/components/ui/buttons';
import { BaseImage } from '@/components/ui/data-display';
import { ErrorMessage, LoadingSpinner } from '@/components/ui/feedback';
import App from './App.vue';
import router from './router';
// fonts
import './theme/fonts/onest/stylesheet.css';
import './theme/main.css';

// App initialization
const pinia = createPinia();

pinia.use(({ store }) => {
    store.router = router;
});

const app = createApp(App)
    .use(IonicVue, {
        mode: 'ios',
        swipeBackEnabled: true,
    })
    .use(router)
    .use(pinia);

// Global components
app.component('BaseLayout', BaseLayout);
app.component('ErrorMessage', ErrorMessage);
app.component('Loading', LoadingSpinner);
app.component('BaseButton', BaseButton);
app.component('BaseImage', BaseImage);

// Mount app
router
    .isReady()
    .then(() => {
        app.mount('#app');
    })
    .then(() => defineCustomElements(window));
